import * as React from "react";
import { cn } from "./utils";

interface ReportBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "outline";
}

function ReportBadge({ className, variant = "default", ...props }: ReportBadgeProps) {
  const variants = {
    default: "border-transparent bg-slate-900 text-white",
    outline: "border-slate-200 bg-transparent text-slate-700",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}

export { ReportBadge };
